import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useState, useEffect } from 'react'
import Plans from './Components/Plans'
import CartSection from './Components/Cart'
import Summary from './Components/Summary'
import Payment from './Components/Payment'



function PurchasePhysicalRechargeVouchers() {

  const [showPlans, setPlans] = useState(true)
  const [showCart, setShowCart] = useState(false)
  const [showSummary, setShowSummary] = useState(false)
  const [showPayment, setShowPayment] = useState(false)
  const [cartData, setCartData] = useState([])
  const [payment_system_token, setpayment_system_token] = useState("")
  const [summaryData, setSummaryData] = useState("")
  const [retailerWalletBalance, setRetailerWalletBalance] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [walletUsedAmount, setWalletUsedAmount] = useState(0);
  const [subtotal, setSubTotal] = useState(0);
  const [discount, setDiscount] = useState(0);

  useEffect(() => {

    if (cartData?.cart_total?.grand_total) {
      setGrandTotal(cartData.cart_total.grand_total)
      setRetailerWalletBalance(cartData.retailer_wallet_balance);
      setWalletUsedAmount(cartData.cart_total.wallet_used_amount)
      setSubTotal(cartData.cart_total.sub_total)
      setDiscount(cartData.cart_total.discount)

    }
  }, [cartData])

  const getShowCart = (input, data) => {
    setShowCart(input)
    setCartData(data)

  }


  const getShowSummary = (input) => {
    setShowSummary(input)
  }

  const getShowPayment = (input) => {
    setShowPayment(input)
  }

  const getShowPlans = (input) => {
    setPlans(input)

  }

  const getPaymentToken = (input) => {
    setpayment_system_token(input)
  }

  const getSummarydata = (input) => {
    setSummaryData(input)
  }


  const getTotalAmount = (input) => {
    setSummaryData(input)
  }




  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        <div>
          {showCart ? (
            <CartSection setShowPayment={getShowPayment} cart={cartData} setShowCart={getShowCart} getCartData={setCartData} paymentToken={getPaymentToken} />
          ) : showPayment ? (
            <Payment paymentToken={payment_system_token} setShowSummary={getShowSummary} setShowPayment={getShowPayment} getSummarydata={setSummaryData} retailerWalletBalance={retailerWalletBalance} grandTotal={grandTotal} walletUsedAmount={walletUsedAmount} subtotal={subtotal} discount={discount} />
          ) : showSummary ? (
            <Summary setShowSummary={getShowSummary} summaryData={summaryData} />
          ) : (
            <Plans setShowCart={getShowCart}  />
          )}
        </div>
      </DashboardLayout>
    </div>
  )
}

export default PurchasePhysicalRechargeVouchers